import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmZonesDropDownDto } from '.';

export class RmZonesDropDownResponseModel extends GlobalResponseObject {
    data?: RmZonesDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: RmZonesDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

